import "./Service.css";
import { TiHtml5 } from "react-icons/ti";
import { IoLogoJavascript } from "react-icons/io";
import { AiOutlineInteraction } from "react-icons/ai";
import { FaReact, FaBootstrap, FaNodeJs } from "react-icons/fa";
import { FaGithub } from "react-icons/fa6";
import { SiJquery, SiNextdotjs, SiNestjs, SiMongodb, SiWordpress } from "react-icons/si";
import { Slide } from "react-awesome-reveal";

export default function Service() {
  const services = [
    {
      icon: <TiHtml5 id="icon" />,
      title: "HTML / CSS",
      desc: "Creating the structure and styling of web pages using HTML and CSS.",
      direction: "left",
    },
    {
      icon: <IoLogoJavascript id="icon" />,
      title: "JavaScript",
      desc: "Implementing dynamic and interactive elements on the webpage, handling user interactions.",
      direction: "up",
    },
    {
      icon: <AiOutlineInteraction id="icon" />,
      title: "Animation & Interaction",
      desc: "Implementing animations and interactive elements to enhance user engagement.",
      direction: "right",
    },
    {
      icon: <FaReact id="icon" />,
      title: "React",
      desc: "Building user interfaces efficiently using modern frontend libraries.",
      direction: "up",
    },
    {
      icon: <SiNextdotjs id="icon" />,
      title: "Next.js",
      desc: "Building fast and SEO-friendly web applications using Next.js framework.",
      direction: "up",
    },
    {
      icon: <FaNodeJs id="icon" />,
      title: "Node.js",
      desc: "Server-side development with Node.js for scalable applications.",
      direction: "left",
    },
    {
      icon: <SiNestjs id="icon" />,
      title: "NestJS",
      desc: "Building structured and scalable backend APIs with NestJS framework.",
      direction: "right",
    },
    {
      icon: <SiMongodb id="icon" />,
      title: "MongoDB",
      desc: "NoSQL database for flexible and scalable data storage.",
      direction: "up",
    },
    {
      icon: <SiWordpress id="icon" />,
      title: "WordPress",
      desc: "Building dynamic websites and online stores using WordPress and WooCommerce.",
      direction: "up",
    },
    {
      icon: <FaBootstrap id="icon" />,
      title: "Bootstrap",
      desc: "Implementing and customizing frontend frameworks for responsive designs.",
      direction: "up",
    },
    {
      icon: <FaGithub id="icon" />,
      title: "Git / Github",
      desc: "Collaborating with developers using Git to track and manage code changes.",
      direction: "up",
    },
    {
      icon: <SiJquery id="icon" />,
      title: "jQuery",
      desc: "Enhancing websites with easy-to-use jQuery utilities and plugins.",
      direction: "up",
    },
  ];

  return (
    <section id="section3">
      <div className="container">
        {services.map((service, index) => (
          <div id="service" key={index}>
            <Slide
              direction={service.direction}
              delay={50 * index}
              triggerOnce
            >
              {service.icon}
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </Slide>
          </div>
        ))}
      </div>
    </section>
  );
}
